/** Shared shell for the shop detail cards: Paper + titled header + a shops:write pencil that opens ShopEditDialog. */
import { useState } from 'react';

import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import type { ShopSummary } from '../../api/types.ts';
import { ShopEditDialog, type ShopEditGroup } from './ShopEditDialog.tsx';

export interface EditableCardProps {
  title: string;
  group: ShopEditGroup;
  shop: ShopSummary;
  canWrite: boolean;
  onSaved: () => void;
  children: React.ReactNode;
}

export function EditableCard({
  title,
  group,
  shop,
  canWrite,
  onSaved,
  children,
}: Readonly<EditableCardProps>): React.JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <Paper sx={{ p: 2.5 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6">{title}</Typography>
        {canWrite && (
          <IconButton
            aria-label={`Edit ${title.toLowerCase()}`}
            onClick={() => setOpen(true)}
            sx={{ minWidth: 44, minHeight: 44 }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      {children}

      <ShopEditDialog open={open} shop={shop} group={group} onClose={() => setOpen(false)} onSaved={onSaved} />
    </Paper>
  );
}

export default EditableCard;
